@if (chosenActiveMethod === null) {
  <h1 class="text-lg fw-600 text-center">Log into AIKosh</h1>
  <p class="text-xs text-secondary text-center mb-3">
    Select any one from the below options
  </p>

  <!-- Warning Alert for Jan Parichay Migration -->
  <div class="login-options-listing">
    @if (false) {
      <div
        class="d-flex justify-content-start align-items-start gap-3 warning-div"
      >
        <img
          src="images/info-box-i-icon.svg"
          height="100%"
          width="100%"
          alt="warning"
        />
        <div class="text-primary-dark">
          <span class="mb-2 text-base fw-500"
            >AIKosh now uses Jan Parichay for login</span
          ><br /><span class="text-sm fw-400"
            >If you previously used Meri Pehchan, please switch to Jan Parichay.
            Your data syncs automatically.</span
          >
        </div>
      </div>
    }
  </div>

  <ul class="login-options-listing list list-unstyled">
    @for (method of loginMethods; track method.id) {
      <li
        [title]="method.title"
        class="login-option cursor-pointer position-relative d-flex align-items-start p-3 mb-4"
        (click)="proceedToLogin(method.id, method.isActive)"
      >
        <!-- [class.disabled]="!method.isActive" -->
        <img
          class="flex-shrink-0 me-4"
          fetchpriority="high"
          width="45"
          height="45"
          [src]="method.isActive ? method.icon : 'images/inactive-auth.svg'"
          [alt]="method.title"
        />
        <div class="w-100">
          <div class="d-flex justify-content-between gap-2">
            <h3
              class="text-xxs fw-500 mb-1"
              [ngClass]="{ 'opacity-50': !method.isActive }"
            >
              {{ method.title }}
            </h3>
            @if (method.logo) {
              <img
                class="option-logo"
                fetchpriority="high"
                width="60"
                height="20"
                [src]="method.logo"
                [title]="method.title"
              />
            }
          </div>
          @if (!method.isActive && method.expiryDate) {
            <p class="text-crimson my-2 description">
              will be Removed after {{ method.expiryDate }}
            </p>
          }
          @if (method.showBetaTag) {
            <p class="text-crimson my-2 description">BETA</p>
          }
          <p
            class="text-secondary mb-0 text-xs"
            [ngClass]="{ 'opacity-50': !method.isActive }"
          >
            {{ method.description }}
          </p>
        </div>
      </li>
    }
  </ul>
  <p class="text-xxs text-black text-center mt-2">
    New to AIKosh?
    <span
      class="text-decoration-underline cursor-pointer text-primary fw-600"
      (click)="goToRegister()"
      >Sign up here</span
    >
  </p>
} @else {
  @if (getChosenMethod(); as method) {
    <!-- IMPORTANT UPDATE badge -->
    <div style="padding: 0 4rem">
      <div class="text-center mb-4">
        <span class="important-update-badge text-btn-color-cancel">
          <img src="images/bell-icon.svg" alt="bell" class="me-2" />IMPORTANT
          UPDATE
        </span>
      </div>

      <h2 class="text-2xl fw-600 text-center mb-3">
        We've upgraded how you sign in
      </h2>
      <p class="text-center text-secondary mb-4">
        AIKosh now uses <strong>Jan Parichay</strong> — India's unified
        government login. Linking your account takes about 2 minutes.
      </p>
    </div>

    <!-- Expiry Warning Box -->
    <div class="login-options-listing">
      <div class="d-flex align-items-start gap-3 warning-div">
        <img
          src="images/info-box-i-icon.svg"
          height="24"
          width="24"
          alt="warning"
        />
        <p class="mb-0 text-primary-dark text-sm">
          {{ method.name }} will be retired on
          <strong>{{ method.expiryDate }}.</strong>
          Switch now to keep uninterrupted access to your data and services.
        </p>
      </div>

      <!-- What Happens Next -->
      <div class="what-happens-next my-5">
        <h3 class="fw-600 mb-5 text-base">What happens next</h3>

        <div
          class="step-item d-flex gap-3 align-items-start mb-3 pb-3 border-bottom"
        >
          <div class="step-number">1</div>
          <div>
            <h4 class="fw-500 mb-1 text-base">
              We'll redirect you to Jan Parichay
            </h4>
            <p class="text-secondary description mb-0">
              Sign in or create a new account using the same email & phone
            </p>
          </div>
        </div>

        <div
          class="step-item d-flex gap-3 align-items-start mb-3 pb-3 border-bottom"
        >
          <div class="step-number">2</div>
          <div>
            <h4 class="fw-500 mb-1 text-base">Your data links automatically</h4>
            <p class="text-secondary description text-sm mb-0">
              All your AIKosh datasets, models, and progress carry over
            </p>
          </div>
        </div>

        <div class="step-item d-flex gap-3 align-items-start">
          <div class="step-number">3</div>
          <div>
            <h4 class="fw-500 mb-1 text-base">You're done</h4>
            <p class="text-secondary description text-sm mb-0">
              Future logins use Jan Parichay — nothing else changes
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="login-options-listing d-flex flex-column gap-3 mt-4">
      <button
        class="btn btn-primary-dark w-100 fw-400"
        style="height: 3rem"
        (click)="getJanParichayUrl()"
      >
        <img src="images/arrow-right-gray.svg" alt="proceed" class="me-2" />
        Link My Account to Jan Parichay
      </button>
      <button
        class="btn btn-bordered-black w-100 fw-400"
        style="height: 3rem"
        (click)="proceedToLogin(method.id, true)"
      >
        Continue with {{ method.name }} for Now
      </button>
    </div>

    <p class="text-center text-secondary text-sm mt-4">
      Having trouble?
      <a
        [routerLink]="['/', routes.home, routes.faqs]"
        class="text-decoration-underline text-black"
        >View FAQ</a
      >
    </p>
  }
}
